import { Action, createReducer, on } from '@ngrx/store';
import { 
    addRecord,
    addRecordFailure,
    addRecordSuccess,
    resetState
} from './support-requests.action';

export interface SupportRequestRecordsState {
    loading: boolean;
    error: any;
}

export const initialState: SupportRequestRecordsState = {
    loading: false,
    error: null,
};


export const supportRequestsRecordReducer = createReducer(

    initialState,
    on(addRecord, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(addRecordSuccess, (state) => {
        return { ...state, loading: false, error: null };
    }),
    on(addRecordFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);